import { configureStore } from '@reduxjs/toolkit';
import { widthsReducer } from '../resizing/redux/widthsSlice';
import { selectionReducer } from '../selection/redux/selectionSlice';
import { rowRegistryReducer } from '../table/redux/rowRegistrySlice';
export const createStore = ({
  initialWidths
}) => configureStore({
  reducer: {
    selection: selectionReducer,
    widths: widthsReducer,
    rowRegistry: rowRegistryReducer
  },
  devTools: {
    name: 'customer-data-table'
  },
  preloadedState: {
    widths: {
      widths: initialWidths
    }
  }
});